<template>

  <div class="col-12 table-responsive">

    <table class="table table-bordered">

      <tr>
        
        <th 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key" >
          {{ tableParameterItem.text || tableParameterItem.key }}
        </th>

      </tr>

      <tr 
        v-for="(leaseDataItem, leaseDataIndex) in leaseData"
        v-show="leaseDataItem.leaseSelected"
        v-bind:key="leaseDataItem.id" >

        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key"
          v-show="!tableParameterItem.hide" >

          <span v-if="tableParameterItem.key === 'index'">{{ leaseDataIndex + 1 }}</span>

          <input
            v-else-if="tableParameterItem.key === 'leaseSelected'"
            v-model="leaseDataItem['leaseSelected']"
            type="checkbox"
            v-bind="leaseEnableEdit ? {} : {'disabled':0}" />

          <div 
            v-else
            v-html="leaseDataItem[tableParameterItem.key]" />
          
        </td>

      </tr>

      <tr>
        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key" >
          {{ leaseTotal[tableParameterItem.key] }}
        </td>

      </tr>
        
    </table>

    *Refundable Fees are parking fees payment previously made which refundable, excluding Deposit.

    <button 
      v-show="leaseEnableAddDelete"
      class="btn btn-rounded btn-primary"
      v-on:click.prevent="onLeaseAddClick">
      Add Product Subscription
    </button>

    <TemplateFeedback ref="leaseFeedback" class="mt-1"/>

  </div>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"

const PARAM = [
  {
    key: 'index',
    text: '#',
  },
  // {
  //   key: 'leaseSelected',
  //   text: ' '
  // },
  {
    key: 'leaseZone',
    text: 'Zone'
  },
  {
    key: 'leaseProductName',
    text: 'Product Name'
  },
  {
    key: 'commencementDateText',
    text: 'Commencement Date',
  },
  {
    key: 'leaseParkerInformation',
    text: 'Parker Information',
  },
  {
    key: 'leasePasscard',
    text: 'Passcard',
  },
  {
    key: 'leaseProductDepositText',
    text: 'Deposit',
  },
  {
    key: 'leaseProductParkingFeeText',
    text: 'Parking Fee',
  },
  {
    key: 'leaseProRatedText',
    text: 'Pro-Rated',
  },
  {
    key: 'leaseCreditAmountText',
    text: 'Credit Amount',
  },
  {
    key: 'leaseRefundableFeesText',
    text: 'Refundable Fees',
  },
];

export default {
  name: "PagePLReactivationFormLease",
  props: ['tableParameter'],
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      PARAM,

      tableSeason: null,
      tableParker: null,

      leaseData: [{}],
      leaseTotal: {},
      leaseEnableAddDelete: false,
      leaseEnableEdit: false,

      PRODUCT_PARAMS: ['leaseProductDeposit', 'leaseProductEstbFee', 'leaseProductInitialParkingFee', 'leaseProductInitialPayment', 'leaseProductParkingFee', 'leaseProRated', 'leaseCreditAmount', 'leaseRefundableFees'],
      PARKER_PARAMS: ['leaseParkerName', 'leaseParkerMobile', 'leaseParkerPlate', 'leaseParkerEmail'],
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
  },
  methods: {
    setLeaseData(leaseData, leaseEnableEdit) {
      this.leaseData = leaseData || [];
      this.leaseEnableEdit = leaseEnableEdit;
    },
    setLeaseTotal(leaseTotal) {
      leaseTotal = leaseTotal || {};
      this.PRODUCT_PARAMS.forEach(k => {
        leaseTotal[k + 'Text'] = leaseTotal[k + 'Text'] || helper.formatMoney(leaseTotal[k]);
      });
      this.leaseTotal = leaseTotal;
    },

    setLeaseDataSeason(data, season) {
      if(!season) {
        data['seasonID'] = null;
        this.removeLeaseDataSeasonField(data);
      }
    },
    setLeaseDataParker(data, parker) {
      if(!parker) {
        data['parkerID'] = null;
        this.removeLeaseDataParkerField(data);
      } else {
        data['leaseParkerInformation'] = helper.plFormParker(parker);
        this.$forceUpdate();
      }
    },
    
    removeLeaseDataSeasonField(data) {
      this.PRODUCT_PARAMS.forEach(k => {
        data[k] = null;
        data[k + 'Text'] = null;
      })
    },
    removeLeaseDataParkerField(data) {
      this.PARKER_PARAMS.forEach(k => {
        data[k] = null;
      })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLReactivationFormLease.vue